import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography, Select, MenuItem } from '@mui/material';
import Iconify from '../../../components/iconify';
import { useState } from 'react';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const statusOptions = [
  { value: 'all', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'going_to_client', label: 'Going to Client' },
  { value: 'started', label: 'Started' },
  { value: 'payment', label: 'Payment' },
  { value: 'finished', label: 'Finished' },
  { value: 'canceled', label: 'Canceled' },
];

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};

export default function UserListToolbar({ name, numSelected, filterTripsByStatus, onFilterName, data }) {
  const [statusFilter, setStatusFilter] = useState('all');

  const handleFilterByStatus = (status) => {
    setStatusFilter(status);
    filterTripsByStatus(status);
  };

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <>
          <Typography component="div" variant="subtitle1">
            {name}
          </Typography>
          {name === 'My Trips' && (
            <>
              {/* <Tooltip title="Filter list">
                <IconButton>
                  <Iconify icon="ic:round-filter-list" />
                </IconButton>
              </Tooltip> */}
              <Select value={statusFilter} onChange={(e) => handleFilterByStatus(e.target.value)} sx={{ ml: 2 }}>
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    <Iconify icon="ic:round-filter-list" sx={{ mr: 2 }} />
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </>
      )}
    </StyledRoot>
  );
}
